import SignupForm from "../../forms/signupForm"

const SignUp = () => {
    return (
        <div>
            <SignupForm />
        </div>
    )
}

export default SignUp;